import { render, staticRenderFns } from "./BrandDetailsButton.vue?vue&type=template&id=6da9ecc8&scoped=true&"
import script from "./BrandDetailsButton.vue?vue&type=script&lang=ts&"
export * from "./BrandDetailsButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da9ecc8",
  null
  
)

export default component.exports